export const setLocalStorage = (key: any, value: any) => {
    localStorage.setItem(key, value);
}
export const getLocalStorage = (key: any) => {
    return localStorage.getItem(key);
}
export const removeLocalStorage = (key: any) => {
    localStorage.removeItem(key);
}
export const clearLocalStoage = () => {
    localStorage.clear();
}
